// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/selectArrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addDancerScroll::-webkit-scrollbar {
  display: none;
}
.addDancerScroll:focus-visible,.addDancerScrollBox:focus-visible{
  outline:none !important;
}
div::-webkit-scrollbar {
  display: none;
}

.boxScroll {
  -ms-overflow-style: none;
  /* Internet Explorer 10+ */
  scrollbar-width: none;
  /* Firefox */
  height: 90vh;
}

.boxScroll::-webkit-scrollbar {
  display: none;
  /* Safari and Chrome */
}
#addDancerinput,
#editDancerinput {
  padding: 0px 30px 0px 20px !important;
}
.addDancermodelLabel label {
  margin-left: 5px !important;
}

.formikSelect {
  /* font-size: 14px; */
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 5%;
  background-position: top 50% right 4%;
  width: 248px;
}

.formikInput::placeholder {
  color: #eaeaea !important;
  font-size: 14px;
}

.formikInput {
  width: 248px;
}
.input-text-accomodation-des::placeholder {
  padding-left: 7px;
}
.input-box-org-des-error::placeholder {
  padding-left: 7px;
}
.add-dancer {
  background-color: #ffffff;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.main-div,
.edit-div {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  height: auto;
  border-radius: 4px !important;
}
.acc-div {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  max-height: 80vh;
  width: 50vw;
  padding:20px;
  border-radius: 4px !important;
}
.acc-outer-div:focus-visible{
outline:none !important;
}
.close-div {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 0px 25px 0px 28px;
  margin-top: 33px;
}

.close-icon {
  cursor: pointer;
  width: 14px;
  color: #a4a4a4;
}

.color-subtitle {
  font-size: 24px;
  font-weight: 400;
}
.acc-desc{
  max-height:50vh;
  overflow:scroll;
}
.MuiBackdrop-root-MuiModal-backdrop {
  position: absolute !important;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-tap-highlight-color: transparent;
  z-index: -1;
  height: 104vh !important;
}

@media ((min-width: 0px) and (max-width:400px)) {
  .edit-div {
    width: auto;
  }
}

@media only screen and (min-width: 0px) and (max-width: 480px) {
  .main-div,
  .edit-div {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    overflow: scroll;
  }
}
@media only screen and (min-width: 0px) and (max-width: 767px) {
  .css-1gpd80c {
    width: 90% !important;
    max-height: 90% !important;
    overflow: scroll;
  }
  .acc-div{
    width:80vw;
    overflow: scroll;
  }
  .acc-desc{
    max-height: auto;
    overflow:auto;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .acc-div{
    width:80vw;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1930px) {
  .login-dancer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 60px;
    width: 37%;
    height: auto;
    left: 50%;
    margin: auto;
    top: calc(50%);
    background: #ffffff;
    box-shadow: 0px 10px 22px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
}

@media only screen and (min-width: 500px) and (max-width: 1900px) {
  .main-div,
  .edit-div {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    height: auto;
    width: 500px;
    border-radius: 4px !important;
  }

  .boxScroll {
    -ms-overflow-style: none;
    /* Internet Explorer 10+ */
    scrollbar-width: none;
    /* Firefox */
    height: 90vh;
  }
}

@media only screen and (min-width: 1900px) {
  .main-div,
  .edit-div {
    display: flex !important;
    flex-direction: column !important;
    background-color: #ffffff !important;
    height: auto !important;
    width: 421px !important;
    margin-bottom: 0rem !important;
  }
}

@media only screen and (min-width: 1100px) and (max-width: 1330px) {
  .MuiBackdrop-root-MuiModal-backdrop {
    position: absolute !important;
    display: flex;
    align-items: center;
    justify-content: center;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-tap-highlight-color: transparent;
    z-index: -1;
    height: 140vh !important;
  }
}

@media only screen and (min-width: 700px) and (max-width: 900px) {
  -modal .css-1gpd80c {
    width: 90% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Modals/AddDancerModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;EACrB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,yDAAmD;EACnD,4BAA4B;EAC5B,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;AACA,uBAAuB;AACvB;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,6BAA6B;EAI7B,aAAa;EAIb,mBAAmB;EAInB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,MAAM;EACN,OAAO;EACP,oCAAoC;EACpC,wCAAwC;EACxC,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,aAAa;EACf;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,4CAA4C;IAC5C,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,qBAAqB;IACrB,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE;;IAEE,wBAAwB;IACxB,iCAAiC;IACjC,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,SAAS;IACT,MAAM;IACN,OAAO;IACP,oCAAoC;IACpC,wCAAwC;IACxC,WAAW;IACX,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".addDancerScroll::-webkit-scrollbar {\n  display: none;\n}\n.addDancerScroll:focus-visible,.addDancerScrollBox:focus-visible{\n  outline:none !important;\n}\ndiv::-webkit-scrollbar {\n  display: none;\n}\n\n.boxScroll {\n  -ms-overflow-style: none;\n  /* Internet Explorer 10+ */\n  scrollbar-width: none;\n  /* Firefox */\n  height: 90vh;\n}\n\n.boxScroll::-webkit-scrollbar {\n  display: none;\n  /* Safari and Chrome */\n}\n#addDancerinput,\n#editDancerinput {\n  padding: 0px 30px 0px 20px !important;\n}\n.addDancermodelLabel label {\n  margin-left: 5px !important;\n}\n\n.formikSelect {\n  /* font-size: 14px; */\n  -webkit-appearance: none;\n  background-image: url(../../Assets/selectArrow.png);\n  background-repeat: no-repeat;\n  background-size: 5%;\n  background-position: top 50% right 4%;\n  width: 248px;\n}\n\n.formikInput::placeholder {\n  color: #eaeaea !important;\n  font-size: 14px;\n}\n\n.formikInput {\n  width: 248px;\n}\n.input-text-accomodation-des::placeholder {\n  padding-left: 7px;\n}\n.input-box-org-des-error::placeholder {\n  padding-left: 7px;\n}\n.add-dancer {\n  background-color: #ffffff;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.main-div,\n.edit-div {\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n  height: auto;\n  border-radius: 4px !important;\n}\n.acc-div {\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n  max-height: 80vh;\n  width: 50vw;\n  padding:20px;\n  border-radius: 4px !important;\n}\n.acc-outer-div:focus-visible{\noutline:none !important;\n}\n.close-div {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  padding: 0px 25px 0px 28px;\n  margin-top: 33px;\n}\n\n.close-icon {\n  cursor: pointer;\n  width: 14px;\n  color: #a4a4a4;\n}\n\n.color-subtitle {\n  font-size: 24px;\n  font-weight: 400;\n}\n.acc-desc{\n  max-height:50vh;\n  overflow:scroll;\n}\n.MuiBackdrop-root-MuiModal-backdrop {\n  position: absolute !important;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -webkit-justify-content: center;\n  justify-content: center;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  -webkit-tap-highlight-color: transparent;\n  z-index: -1;\n  height: 104vh !important;\n}\n\n@media ((min-width: 0px) and (max-width:400px)) {\n  .edit-div {\n    width: auto;\n  }\n}\n\n@media only screen and (min-width: 0px) and (max-width: 480px) {\n  .main-div,\n  .edit-div {\n    display: flex;\n    flex-direction: column;\n    background-color: #ffffff;\n    overflow: scroll;\n  }\n}\n@media only screen and (min-width: 0px) and (max-width: 767px) {\n  .css-1gpd80c {\n    width: 90% !important;\n    max-height: 90% !important;\n    overflow: scroll;\n  }\n  .acc-div{\n    width:80vw;\n    overflow: scroll;\n  }\n  .acc-desc{\n    max-height: auto;\n    overflow:auto;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n  .acc-div{\n    width:80vw;\n  }\n}\n@media only screen and (min-width: 1200px) and (max-width: 1930px) {\n  .login-dancer {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 60px;\n    width: 37%;\n    height: auto;\n    left: 50%;\n    margin: auto;\n    top: calc(50%);\n    background: #ffffff;\n    box-shadow: 0px 10px 22px rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n  }\n}\n\n@media only screen and (min-width: 500px) and (max-width: 1900px) {\n  .main-div,\n  .edit-div {\n    display: flex;\n    flex-direction: column;\n    background-color: #ffffff;\n    height: auto;\n    width: 500px;\n    border-radius: 4px !important;\n  }\n\n  .boxScroll {\n    -ms-overflow-style: none;\n    /* Internet Explorer 10+ */\n    scrollbar-width: none;\n    /* Firefox */\n    height: 90vh;\n  }\n}\n\n@media only screen and (min-width: 1900px) {\n  .main-div,\n  .edit-div {\n    display: flex !important;\n    flex-direction: column !important;\n    background-color: #ffffff !important;\n    height: auto !important;\n    width: 421px !important;\n    margin-bottom: 0rem !important;\n  }\n}\n\n@media only screen and (min-width: 1100px) and (max-width: 1330px) {\n  .MuiBackdrop-root-MuiModal-backdrop {\n    position: absolute !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    -webkit-tap-highlight-color: transparent;\n    z-index: -1;\n    height: 140vh !important;\n  }\n}\n\n@media only screen and (min-width: 700px) and (max-width: 900px) {\n  -modal .css-1gpd80c {\n    width: 90% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
